import { Button } from "@mui/material";
import styles from './Buttons.module.scss';

interface Props {
    id: string;
    label: any;
    onclickHandler: any;
    customStyle?: any;
    disabled?: any;
}

export default function BorderlessButton ({id, label, onclickHandler, customStyle, disabled}: Props){

    return (
        <Button
            sx={customStyle}
            size="small"
            id={id}
            className={[styles.btn, styles.normalButton].join(" ")}
            onClick={onclickHandler}
            variant="text"
            disabled={disabled}
        >
            {label}
        </Button>
    )
}